/**
 * Created by okolesnikov.
 */
import {BonusScene} from 'bonus_scene';

import {Animation} from 'animation';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

const PRIZE_NUMBER = 8;

function createAnimation(name_pattern, framesCount, speed = 0.2, loop = false) {

    let anim = Animation.byFrameName(name_pattern, framesCount);
    anim.animationSpeed = speed;
    anim.loop = loop;

    return anim;
}

export default class SuperBonusGameScene extends BonusScene {
    
    constructor(space) {
        super();

        this.interactive = true;

        this.background = new Sprite(TextureCache['res/superBonus/super_background.jpg']);
        this.addChild(this.background);

        this.backContainer = new PIXI.Container();
        this.addChild(this.backContainer);

        this.traderContainer = new PIXI.Container();

        const body = new Sprite(TextureCache['trader_body.png']);
        this.traderContainer.addChild(body);

        const hand = new Sprite(TextureCache['trader_hand.png']);
        hand.position.set(-215, 56);
        this.traderContainer.addChildAt(hand, 0);

        this.animTraderIdle = createAnimation('trader_idle_%03d.png', 30, 0.2, true);
        this.animTraderIdle.position.set(73, -112);
        this.traderContainer.addChild(this.animTraderIdle);

        this.animTraderLose = createAnimation('trader_lose_%03d.png', 30, 0.3);
        this.animTraderLose.position.set(73, -112);
        this.traderContainer.addChild(this.animTraderLose);

        this.animTraderWin = createAnimation('trader_win_%03d.png', 30, 0.5);
        let revTexture = this.animTraderWin.textures.slice().reverse();
        this.animTraderWin.textures = this.animTraderWin.textures.concat(revTexture);
        this.animTraderWin.position.set(73, -112);
        this.traderContainer.addChild(this.animTraderWin);

        this.traderContainer.position.set(419, 212);
        this.addChild(this.traderContainer);

        const foreground = new Sprite(TextureCache['super_foreground.png']);
        foreground.position.set(0, 440);
        this.addChild(foreground);

        const prizeCoords = [
            { x: -58, y: 219 }, //0
            { x: 200, y: 395 }, //1
            { x: 357, y: 404 }, //2
            { x: 565, y: 413 },  //3
            { x: 729, y: 0 },  //4
            { x: 519, y: 0 },  //5
            { x: 192, y: 5 },  //6
            { x: 42,  y: 90 }   //7
        ];

        const markerOffsets = [
            { x: 132+27, y: 155+27 }, //0
            { x: 120+27, y: 61+27 }, //3
            { x: 127+27, y: 39+27 }, //4
            { x: 174+27, y: 143+27 }, //6
            { x: 135+27, y: 221+27 }, //7
            { x: 282+27, y: 74+27 }, //5
            { x: 120+27, y: 191+27 }, //2
            { x: 87+27,  y: -11+27 }, //1
        ];

        const prizeFrames = [
            [10, 10],
            [20, 19],
            [16, 16],
            [2, 2],
            [21, 10],
            [16, 13],
            [15, 12],
            [13, 13],
        ]

        this.prizes = [];
        this.prizeWinAnimations = [];
        this.prizeLoseAnimations = [];

        for (let i = 0; i < PRIZE_NUMBER; ++i) {
            let prize = new Sprite(TextureCache['prize_%d_idle_0.png'.$(i)]);
            prize.position = prizeCoords[i];

            if (i < 5) {
                this.addChild(prize);
            }
            else {
                this.backContainer.addChild(prize);
            }
            this.prizes.push(prize);

            let lightPrize = new Sprite(TextureCache['prize_%d_idle_1.png'.$(i)]);
            prize.addChild(lightPrize);

            let animWin = createAnimation('prize_' + i + '_win_%03d.png', prizeFrames[i][0]);
            animWin.position = prizeCoords[i];
            if (i < 5) {
                this.addChild(animWin);
            }
            else {
                this.backContainer.addChild(animWin);
            }
            this.prizeWinAnimations.push(animWin);

            let animLose = createAnimation('prize_' + i + '_lose_%03d.png', prizeFrames[i][1]);
            animLose.position = prizeCoords[i];
            if (i < 5) {
                this.addChild(animLose);
            }
            else {
                this.backContainer.addChild(animLose);
            }
            this.prizeLoseAnimations.push(animLose);
        }

        this.markerAnimations = [];
        for (let i = 0; i < PRIZE_NUMBER; ++i) {
            let anim = createAnimation('marker_%d.png', 3);
            anim.position.set(prizeCoords[i].x + markerOffsets[i].x, prizeCoords[i].y + markerOffsets[i].y);
            this.addChild(anim);
            this.markerAnimations.push(anim);

            let label = new BitmapText((i+1).toString(), {font: "marker_font", align: "center"});
            label.anchor.set(0.5, 0.5);
            label.position.set(26, 22);
            anim.addChild(label);
        }

        this.labelBonusWin = new BitmapText("123456789", {font: "bonus_totalwin_font", align: "center"});
        this.labelBonusWin.anchor.x = 0.5;
        this.labelBonusWin.position.set(512, 700);
        this.addChild(this.labelBonusWin);

        const labelCoords = [
            { x:132, y:155+219-60 }, //0
            { x:120+200+20, y: 61+396-28 }, //1
            { x:127+357+35, y: 39+404+120 }, //2
            { x:174+565-40, y:143+413-120 }, //3
            { x:135+729, y:221+0+10 }, //4
            { x:282+519+32, y: 74+0-20 }, //5
            { x:120+192+0, y:191+5-130 }, //6
            { x:87+42+65,  y:-11+90+100 }, //7
        ];


        this.winLabels = [];
        for (let i = 0; i < PRIZE_NUMBER; ++i) {
            let label = new BitmapText((i+1).toString(), {font: "super_bonus_win_font", align: "center"});
            label.anchor.set(0.5, 0.5);
            label.position = labelCoords[i];
            this.addChild(label);

            this.winLabels.push(label);
        }

        this.tableEndBonus = new Sprite(TextureCache["table_after_bonus.png"]);
        this.tableEndBonus.anchor.set(0.5, 0.5);
        this.tableEndBonus.position.set(1024/2, 768/2 - 50);
        this.tableEndBonus.visible = false;
        this.addChild(this.tableEndBonus);

        this.labelTableWin = new BitmapText("123456789", {font: "bonus_table_font", align: "center"});
        this.labelTableWin.anchor.x = 0.5;
        this.labelTableWin.position.set(0, -30);
        this.tableEndBonus.addChild(this.labelTableWin);

        this.pressFinish = new Sprite(TextureCache["press_finish.png"]);
        this.pressFinish.anchor.x = 0.5;
        this.pressFinish.position.set(0, 80);
        this.tableEndBonus.addChild(this.pressFinish);

        this.tableEndBonus.interactive = false;
        this.tableEndBonus.pointerdown = event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button != 0) {
                return;
            }
            space.s('ui:finish').next();
            this.tableEndBonus.interactive = false;
        };

        this.sndFon = sounds.get("res/sounds/super_bonus/super_bonus_music");
        this.sndFon.loop(true);

        this.sndChoice = sounds.get("res/sounds/super_bonus/super_bonus_choice");
        this.sndShowWin = sounds.get("res/sounds/bonus/bonus_show_win");
        this.sndShowWin.volume(0.4);
        this.sndTraderLose = sounds.get("res/sounds/super_bonus/trader_lose");
        this.sndTraderWin = sounds.get("res/sounds/super_bonus/trader_win");

        this.sndLose = [];
        this.sndWin = [];
        for (let i = 0; i < PRIZE_NUMBER; ++i) {
            this.sndLose.push(sounds.get("res/sounds/super_bonus/prizes/prize_lose_%d".$(i)));
            this.sndWin.push(sounds.get("res/sounds/super_bonus/prizes/prize_win_%d".$(i)));
        }

        this.sndFlow = sounds.get("res/sounds/bonus/bonus_flow");
        this.sndFlow.loop(true);
        this.sndFlow.volume(0.3);
        this.sndFlowStart = sounds.get("res/sounds/bonus/bonus_flow_start");
        this.sndFlowStart.on('end', () => {
            this.sndFlow.play();
        });

        this.sndShowTable = sounds.get("res/sounds/show_table");
        this.sndShowTable.loop(true);

        this.blinkTweens = [];
        this.intervalShowCell = null;
        this.currentPrize = 0;
        this.currentBonusWin = null;
        this.flowTweens = [];

        // this.clickArea = new PIXI.Graphics();
        // this.clickArea.hitArea = new PIXI.Rectangle(0, 0, 1024, 768);
        // this.clickArea.pointerdown = () => {
        //     this.selectPrize();
        // };
        // this.clickArea.interactive = false;
        // this.addChild(this.clickArea);

        const hitParamPrizes = [
            {x: 53, y: 27, width: 211, height: 288},
            {x: 64, y: 34, width: 152, height: 138},
            {x: 71, y: 72, width: 189, height: 98},
            {x: 57, y: 64, width: 174, height: 111},
            {x: 92, y: 246, width: 207, height: 274},
            {x: 76, y: 0, width: 273, height: 330},
            {x: 75, y: 92, width: 100, height: 130},
            {x: 107, y: 21, width: 86, height: 346},
        ];

        this.prizes.forEach((pr, idx) => {

            let params = hitParamPrizes[idx];

            pr.hitArea = new PIXI.Rectangle(params.x, params.y, params.width, params.height);
            pr.interactive = false;

            pr.pointerdown = () => {
                console.log('click ', idx);
                this.selectPrize(idx);
            }
        })

    };
    
    terminate() {

        this.pause();

        this.sndChoice.stop();
        this.sndShowWin.stop();
        this.sndTraderLose.stop();
        this.sndTraderWin.stop();
        this.sndFlow.stop();
        this.sndFlowStart.stop();
        this.sndFlowStart.off('end');
        this.sndLose.forEach(snd => snd.stop());
        this.sndWin.forEach(snd => snd.stop());

        this.tableEndBonus.removeListener('pointerdown');
        this.prizes.forEach(pr => pr.removeListener('pointerdown'));

        this.prizeWinAnimations.forEach(anim => anim.stop());
        this.prizeLoseAnimations.forEach(anim => anim.stop());
        this.markerAnimations.forEach(anim => anim.stop());
        this.animTraderIdle.stop();
        this.animTraderLose.stop();
        this.animTraderWin.stop();

        this.backContainer.removeChildren();

        this.removeChildren();
        this.destroy();

        this.background = null;
        this.prizes = null;
        this.prizeLoseAnimations = null;
        this.prizeWinAnimations = null;
        this.markerAnimations = null;
        this.labelBonusWin = null;
        this.tableEndBonus = null;
        this.labelTableWin = null;
        this.pressFinish = null;
        this.winLabels = null;
        this.animTraderIdle = null;
        this.animTraderLose = null;
        this.animTraderWin = null;
        this.traderContainer = null;

        this.sndFon = null;
        this.sndShowTable = null;
        this.sndChoice = null;
        this.sndShowWin = null;
        this.sndTraderLose = null;
        this.sndTraderWin = null;
        this.sndFlow = null;
        this.sndFlowStart = null;
        this.sndLose = null;
        this.sndWin = null;

    };

    pause() {

        this.prizes.forEach(pr => pr.interactive = false);

        if (this.timerTrader) {
            clearTimeout(this.timerTrader);
            this.timerTrader = null;
        }

        if (this.intervalShowCell) {
            clearInterval(this.intervalShowCell);
            this.intervalShowCell = null;
        }

        if (this.finishBlinkTween) {
            this.finishBlinkTween.stop();
        }

        this.blinkTweens.forEach(tw => tw.stop());
        this.blinkTweens = [];

        this.flowTweens.forEach(tw => tw.stop());
        this.flowTweens = [];

        this.sndFon.stop();
        this.sndShowTable.stop();

    };

    enableVisiblePrize() {

        this.prizes.forEach(pr => {
            if (pr.visible) {
                pr.interactive = true;
            }
        })

    };

    selectPrize(number) {
        //this.clickArea.interactive = false;
        this.prizes.forEach(pr => pr.interactive = false);

        if (this.intervalShowCell) {
            clearInterval(this.intervalShowCell);
            this.intervalShowCell = null;
        }

        if (number !== undefined) {
            this.currentPrize = number;
        }

        this.markerAnimations[this.currentPrize].gotoAndStop(0);

        this.blinkTweens.forEach(tw => tw.stop());
        this.blinkTweens = [];

        this.sndChoice.play();

        this.onUserSelect(this.currentPrize);
    }
        
        // @overridden
    selectionHasMade(variant) {

    };

    startBlinkPrize() {

        this.blinkTweens.forEach(tw => tw.stop());
        this.blinkTweens = [];

        this.prizes.forEach(prize => {

            if (prize.visible) {
                let light = prize.getChildAt(0);
                light.visible = true;
                light.alpha = 1.0;
                let blinkTween = new TWEEN.Tween(light)
                    .to({alpha: 0}, 1000)
                    .yoyo(true)
                    .repeat(Infinity)
                    .easing(TWEEN.Easing.Cubic.InOut)
                    .start();

                this.blinkTweens.push(blinkTween);
            }
        })
    };

    startSelectedPrize() {

        const mapIndexAccesPrize = [];
        this.prizes.forEach((prize, idx) => {
            if (prize.visible) {
                mapIndexAccesPrize.push(idx);
            }
        });

        //console.log(mapIndexAccesPrize);

        if (mapIndexAccesPrize.length > 0) {

            let currentId = 0;

            this.currentPrize = mapIndexAccesPrize[currentId];
            this.markerAnimations[this.currentPrize].gotoAndStop(0);

            this.intervalShowCell = setInterval(() => {
                this.markerAnimations[this.currentPrize].gotoAndStop(1);
                currentId = (currentId + 1) % mapIndexAccesPrize.length;
                this.currentPrize = mapIndexAccesPrize[currentId];
                this.markerAnimations[this.currentPrize].gotoAndStop(0);
            }, 500)
        }
        else {
            console.log("no prizes accessible!!!!!!");
        }

    };

    restoreBonus(data) {

        const scenarioData = data.server.scenarioData || [];
        const wins = data.state.stage.math.bonus2Wins || [];
        const mult = data.server.betValue.multiplier;

        this.currentBonusWin = data.server.totalWinInCoins;
        if (wins.length > 0) {
            for(let i = 0; i < wins.length; ++i) {
                this.currentBonusWin -= wins[i] * mult;
            }
        }
        this.labelBonusWin.text = this.currentBonusWin ? ('WIN ' +  this.currentBonusWin) : " ";

        this.prizeWinAnimations.forEach(anim => anim.visible = false);
        this.prizeLoseAnimations.forEach(anim => anim.visible = false);
        this.prizes.forEach(prize => prize.visible = true);
        this.winLabels.forEach(l => l.visible = false);

        this.markerAnimations.forEach(anim => {
            anim.visible = true;
            anim.gotoAndStop(1);
        });

        this.animTraderWin.visible = false;
        this.animTraderLose.visible = false;
        this.animTraderIdle.visible = true;

        if (scenarioData.length > 0) {
            //this.clickArea.interactive = false;
            this.prizes.forEach(pr => pr.interactive = false);

            for (let i = 0; i < scenarioData.length - 1; ++i) {
                let prizeId = scenarioData[i];

                this.markerAnimations[prizeId].visible = false;
                this.prizes[prizeId].visible = false;
                this.prizeWinAnimations[prizeId].gotoAndStop(this.prizeWinAnimations[prizeId].textures.length - 1);
                this.prizeWinAnimations[prizeId].visible = true;

                this.winLabels[prizeId].text = wins[i] * mult;
                this.winLabels[prizeId].visible = true;
            }
        }
        else {

            this.startBlinkPrize();
            this.startSelectedPrize();
            //this.clickArea.interactive = true;
            this.enableVisiblePrize();

            this.animTraderIdle.gotoAndPlay(0);
        }

        this.tableEndBonus.visible = false;
        this.tableEndBonus.interactive = false;

        if (!this.sndFon.playing()) {
            this.sndFon.play();
        }

    };

    flowWin(arrWin, arrSelect, mult, done) {

        this.flowTweens.forEach(tw => tw.stop());
        this.flowTweens = [];

        const flowTimeCoeff = 400;

        let order = (arrWin[arrWin.length - 1] === 0) ? arrSelect.slice(0, -1) : arrSelect.slice();
        order.sort((a, b) => {
            return a - b;
        });

        order.forEach((labelId, idx) => {

            let addWin = arrWin[arrSelect.indexOf(labelId)] * mult;

            const time = flowTimeCoeff * Math.log(addWin) || 100;

            const winEntity = {
                value: addWin,
                from: addWin
            };

            let flowTween = new TWEEN.Tween(winEntity)
                .to({value: 0}, time)
                .onStart(() => {
                    //console.log(winEntity.value);
                    //this.sndFlowStart.play();
                })
                .onUpdate(() => {
                    const value = winEntity.value | 0;
                    const delta = winEntity.from - value;
                    winEntity.from -= delta;

                    this.currentBonusWin += delta;
                    this.labelBonusWin.text = 'WIN ' + Math.floor(this.currentBonusWin);
                    this.winLabels[labelId].text = value.toString();
                })
                .onComplete(() => {

                    // this.sndFlowStart.stop();
                    // this.sndFlow.stop();

                    this.winLabels[labelId].visible = false;
                    this.labelBonusWin.text = 'WIN ' +  Math.floor(this.currentBonusWin);

                    if (idx === order.length - 1) {

                        this.sndFlowStart.stop();
                        this.sndFlow.stop();

                        done();
                    }
                });

            if (idx > 0) {
                this.flowTweens[this.flowTweens.length - 1].chain(flowTween);
            }
            this.flowTweens.push(flowTween);

        });

        if (this.flowTweens[0]) {
            this.sndFlowStart.play();
            this.flowTweens[0].start();
        }
        else {
            done();
        }

    };

    // @overridden
    showResult (data, done) {

        console.log('show result data:', data);

        const scenarioData = data.server.scenarioData || [];
        const wins = data.state.stage.math.bonus2Wins || [];
        const mult = data.server.betValue.multiplier;

        let selectPrize = 0;
        let currentWin = 0;

        const showWin = () => {

            this.prizes[selectPrize].visible = false;
            this.prizeWinAnimations[selectPrize].visible = true;

            this.animTraderIdle.visible = false;
            this.animTraderWin.visible = true;
            this.animTraderWin.gotoAndStop(0);

            this.animTraderWin.onComplete = () => {

                //this.sndTraderWin.play();

                if (scenarioData.length < PRIZE_NUMBER) {

                    this.animTraderWin.visible = false;
                    this.animTraderIdle.visible = true;
                    this.animTraderIdle.gotoAndPlay(0);

                    this.startBlinkPrize();
                    this.startSelectedPrize();
                    //this.clickArea.interactive = true;
                    this.enableVisiblePrize();

                    done();
                }
                else {
                    this.flowWin(wins, scenarioData, mult, done);
                }
            };

            this.animTraderWin.onFrameChange = (frame) => {
                if (frame === 10 || frame === 11) {
                    this.sndWin[selectPrize].stop();
                    if (!this.sndTraderWin.playing()) {
                        this.sndTraderWin.play();
                    }
                }
            };

            this.prizeWinAnimations[selectPrize].onComplete = () => {

                this.winLabels[selectPrize].text = currentWin;
                this.winLabels[selectPrize].visible = true;

                this.sndShowWin.play();

                this.timerTrader = setTimeout(() => {
                    this.animTraderWin.gotoAndPlay(0);
                }, 1000);
                // this.animTraderWin.gotoAndPlay(0);
                // this.sndTraderWin.play();

            };

            this.prizeWinAnimations[selectPrize].gotoAndPlay(0);
            this.sndWin[selectPrize].play();

        };

        const showLose = () => {
            this.prizes[selectPrize].visible = false;
            this.prizeLoseAnimations[selectPrize].visible = true;

            this.animTraderIdle.visible = false;
            this.animTraderLose.visible = true;
            this.animTraderLose.gotoAndStop(0);

            this.animTraderLose.onComplete = () => {
                if (wins.length > 1) {
                    this.flowWin(wins, scenarioData, mult, done);
                }
                else {
                    done();
                }
            };

            this.prizeLoseAnimations[selectPrize].onComplete = () => {

                this.timerTrader = setTimeout(() => {
                    this.animTraderLose.gotoAndPlay(0);
                    this.sndTraderLose.play();
                }, 1000);

                // this.animTraderLose.gotoAndPlay(0);
                // this.sndTraderLose.play();
            };

            this.prizeLoseAnimations[selectPrize].gotoAndPlay(0);
            this.sndLose[selectPrize].play();
        };

        if (scenarioData.length > 0) {

            selectPrize = scenarioData[scenarioData.length - 1];
            currentWin = wins[wins.length - 1] * mult;

            this.markerAnimations[selectPrize].onComplete = () => {
                this.markerAnimations[selectPrize].visible = false;
                this.markerAnimations[selectPrize].gotoAndStop(1);

                if (currentWin > 0) {
                    showWin();
                }
                else {
                    showLose();
                }
            };

            this.animTraderIdle.gotoAndStop(0);
            this.markerAnimations[selectPrize].gotoAndPlay(0);

            // done();
        }
        else {
            done();
        }

    };

    // @overridden
    showFinishTable(stageMath, bet, done) {
        console.log("SHOW BONUS TABLE: ", stageMath , bet);

        this.sndFon.stop();
        this.sndShowTable.play();

        this.labelTableWin.text = (stageMath.featureWin * bet.multiplier).toString();
        this.tableEndBonus.visible = true;
        this.tableEndBonus.interactive = true;

        this.pressFinish.visible = true;
        this.pressFinish.alpha = 1;
        this.finishBlinkTween = new TWEEN.Tween(this.pressFinish)
            .to({alpha: 0}, 500)
            .yoyo(true)
            .repeat(Infinity)
            .easing(TWEEN.Easing.Cubic.InOut)
            .start();

        done();
    };
}



// WEBPACK FOOTER //
// ./src/superbonusgame_scene.es6